export default {
  commentCell: {
    whiteSpace: 'nowrap',
    width: '120px'
  },
  center: {
    textAlign: 'center'
  },
  statusCell: {
    textAlign: 'center',
    width: '100px'
  }
}
